/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 17:24:55
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/toolbar.js
 */
import { t } from '../../libs/i18n'
export default {
    // toolbar 组件
    toolbar: {
        show: true,
        cancelText: t('up.common.cancel'),
        confirmText: t('up.common.confirm'),
        cancelColor: '#909193',
        confirmColor: '',
        title: ''
    }

}
